var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 2.5H10.6667C9.95942 2.5 9.28115 2.78095 8.78105 3.28105C8.28095 3.78115 8 4.45942 8 5.16667V14.5C8 13.9696 8.21071 13.4609 8.58579 13.0858C8.96086 12.7107 9.46957 12.5 10 12.5H14.6667V2.5Z",
    stroke: "#627184",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 2.5H5.3335C6.04074 2.5 6.71902 2.78095 7.21911 3.28105C7.71921 3.78115 8.00016 4.45942 8.00016 5.16667V14.5C8.00016 13.9696 7.78945 13.4609 7.41438 13.0858C7.0393 12.7107 6.5306 12.5 6.00016 12.5H1.3335V2.5Z",
    stroke: "#627184",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBookIcon);
export default __webpack_public_path__ + "static/media/open_book_Icon.f3519c201ad0e0e03a0247fc934364bb.svg";
export { ForwardRef as ReactComponent };